import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FadeUp } from "./FadeUp";

const FAQS = [
  { q: "Is it for beginners?", a: "Yes. FORGE builds your plan based on your current fitness level, so it works whether you're just starting out or already experienced." },
  { q: "Can I use it at home without a gym?", a: "Absolutely. When you tell us you train at home, your workout plan is built around bodyweight and minimal equipment exercises." },
  { q: "Does it have vegetarian plans?", a: "Yes, every diet plan can be set to veg or non-veg, and you can swap any meal for another Indian dish anytime." },
  { q: "How is the plan personalized?", a: "Your age, height, weight, goal, diet preference and training location are all used by our AI to build a plan made for you." },
  { q: "Can I cancel anytime?", a: "Yes, Pro and Coaching plans can be cancelled anytime with no lock-in." },
  { q: "Are my photos private?", a: "Yes. Your physique check-in photos are private — only you and Coach Arjun can see them. They are never shown on the community feed." },
  { q: "How does the AI check-in work?", a: "Upload a front and side photo each week. Our AI compares them with your previous check-in and shows what's changed, plus 3 suggestions to improve further." },
  { q: "What's in the progress report?", a: "A weekly or monthly PDF with your muscle heatmap, strength gains, weight change and an AI summary of your overall progress." },
  { q: "How do I open the app?", a: "FORGE opens right inside your member dashboard — no separate login or app download needed." },
  { q: "Can I upgrade later?", a: "Yes, you can upgrade from Free to Pro or Coaching anytime, instantly." },
];

export const FAQSection = () => (
  <section id="faq" className="py-14 md:py-20 px-6 bg-[#111113]">
    <div className="max-w-3xl mx-auto">
      <FadeUp>
        <h2 className="font-display text-4xl sm:text-5xl text-white text-center mb-10 md:mb-14">FAQ</h2>
      </FadeUp>
      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`item-${i}`}
            data-testid={`faq-item-${i + 1}`}
            className="bg-[#1A1A1D] border border-[#2a2a2e] rounded-2xl px-6"
          >
            <AccordionTrigger className="tap-target text-white text-left hover:text-[#C6FF3D] hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[#A1A1AA]">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
